import { Flex } from '@teamsparta/stack-flex';
import type { ReactNode } from 'react';

import type { TextAlign } from '../../type';
import { CardBackground } from '../CardBackground/template';
import { CardTitle } from '../CardTitle/template';
import * as S from './style';

interface CardProps {
  title: string;
  titleBackground?: 'sm' | 'md' | 'lg';
  children: ReactNode;
  textAlign?: TextAlign;
}

export function Card({
  title,
  children,
  textAlign = 'left',
  titleBackground = 'sm',
}: CardProps) {
  return (
    <Flex.Column align='center' style={{ width: '100%' }}>
      <S.TitleContainer>
        <CardTitle titleBackground={titleBackground}>{title}</CardTitle>
      </S.TitleContainer>
      <CardBackground textAlign={textAlign}>{children}</CardBackground>
    </Flex.Column>
  );
}
